export default __webpack_public_path__ + "static/sara-petrocchi-772713fe49772e72116d3da1f43b8c17.jpg";